/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

require('./services/auth.js')
require('./services/can.js')

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

window._ = require('lodash');

import moment from 'moment';
moment.locale("nl");
Vue.prototype.$moment = moment

import fab from 'vue-fab'
Vue.component('fab', fab);

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

import Pusher from 'pusher-js'

var pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
  cluster: 'eu',
  forceTLS: true,
  authEndpoint: 'https://staffapi.hebtrek.nl/v1/broadcasting/auth',
  auth: {
    headers: {
      Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
    }
  }
})

Vue.prototype.$pusher = pusher

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import VueEvents from 'vue-events'
Vue.use(VueEvents)

// Feather font icon
require('./assets/css/iconfont.css')

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

import helpers from './helpers.js';

const plugin = {
  install () {
    Vue.helpers = helpers;
    Vue.prototype.$util = helpers;
  }
};

Vue.use(plugin);
